module.exports = __webpack_public_path__ + "assets/T2_CircleDetailed.4468f2ac8e15dfac2e93d84a4fa61b6b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/png/levels/1x/T2_CircleDetailed.png
// module id = 573
// module chunks = 0